import Vue from 'vue'
import Component from './CarouselDialog'

const CarouselConstructor = Vue.extend(Component);

export default (options) => {
  const instance = new CarouselConstructor({
    propsData: {...options}
  });
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instance.vm.$on('close', () => {
    instance.vm.visible = false;
    document.body.removeChild(instance.vm.$el);
    instance.vm.$destroy(); //只会删除vm对象，不会删除vm节点
  });
}
